import React from 'react';
import styled from 'styled-components';
import { Chip } from '../../../elements/Chip';
const Wrapper = styled.div `
  position: relative;
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  padding: 8px 16px 8px calc(16px + 2px);
`;
export const ChipCell = ({ value, ...props }) => {
    return (React.createElement(Wrapper, null,
        React.createElement(Chip, { ...props }, value)));
};
//# sourceMappingURL=ChipCell.js.map